import React from "react";
import PropTypes from "prop-types";
import { FaStarOfLife } from "react-icons/fa";

export default function InputField({
  icon,
  label,
  isRequired,
  error,
  register,
  name,
  type = "text",
  placeholder,
  className = "",
  parentClassName = "",
  ...rest
}) {
  return (
    <div className={parentClassName}>
      <label className="flex items-center gap-2 mb-1 text-lg text-gray-800">
        {icon}
        {label}
        {isRequired && <FaStarOfLife className="text-red-800 text-[6px]" />}
      </label>
      <input
        {...register(name)}
        type={type}
        placeholder={placeholder}
        className={`w-full rounded-xl border border-gray-400 focus:outline-customer-primary py-3 pr-8 pl-4 text-xl sm:text-sm ${className}`}
        {...rest}
      />
      {error && <p className="text-red-600 text-sm mt-1">{error.message}</p>}
    </div>
  );
}

// ✅ Add PropTypes for validation
InputField.propTypes = {
  icon: PropTypes.node, // React element (e.g., an icon)
  label: PropTypes.string.isRequired, // Label text (required)
  isRequired: PropTypes.bool, // Whether the field is required
  error: PropTypes.shape({
    message: PropTypes.string, // Error message if validation fails
  }),
  register: PropTypes.func.isRequired, // Function from react-hook-form
  name: PropTypes.string.isRequired, // Input name (required)
  type: PropTypes.string, // Input type (default: "text")
  placeholder: PropTypes.string, // Placeholder text
  className: PropTypes.string, // Additional class names
  parentClassName: PropTypes.string, // Additional class names
};
